module.exports = __webpack_public_path__ + "static/media/FileAdd.f530a693.svg";